// extracted by mini-css-extract-plugin
export default {"container":"DocumentsPage_container__2ITzc"};